<div class="row">
    <div class="col-md-12">
        <h2>FAQ</h2>
        </div>
    </div>
    <app-home-card-config [contenttype]="'home_faq'">></app-home-card-config>
    